import { FabriqAuth } from "@/classes/FabriqAuth";

const AuthClient = new FabriqAuth();

export { AuthClient };
